import { DateInputValue } from "basis";
import { OptionsValues } from "components/types";
import { ActionMap } from "library/ActionMap";
import { AccountInfo } from "library/hooks/types";
import { yesNoOptions } from "library/sharedOptions";
import { MakeRequired } from "library/utils";
import { Dispatch } from "react";
import {
  actionOptions,
  authorityLevelOptions,
  primaryContactOptions,
  relationshipOptions,
  removalTypeOptions,
} from "./options";

export type ScreenComponentType = React.FC<ScreenProps>;
export type PageInfo = {
  [key: string]: {
    heading: string;
    headingIcon?: string;
    screenComponent: ScreenComponentType;
  };
};

export type FormValues = {
  firstName: string;
  lastName: string;
  dateOfBirth: DateInputValue;
  relationship: OptionsValues<typeof relationshipOptions>;
  products1: boolean;
  products2: boolean;
  products3: boolean;
  mobileNumber: string;
  action: OptionsValues<typeof actionOptions>;
  accounts: { [id: string]: string };
  other: string;
  authorityLevel: OptionsValues<typeof authorityLevelOptions>;
  organisationOrFinancialCounsellor: OptionsValues<typeof yesNoOptions>;
  removalType: OptionsValues<typeof removalTypeOptions>;
  addingPoaGuardianOrAdministrator: boolean;
  contactNumber: string;
  contactName: string;
  address: string;
  dateOfBirth2: DateInputValue;
  suburb: string;
  state: string;
  postcode: string;
  email: string;
  nominatedFullName: string;
  organisationOrFinancialCounsellorsName: string;
  primaryContact: OptionsValues<typeof primaryContactOptions>;
};

export enum ActionType {
  ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED",
  FORM_SUBMITTED = "FORM_SUBMITTED",
}

export interface State {
  page: string;
  formValues: FormValues;
  postReduceCreditLimitHref?: string;
  errorType?: string;
  accountInfo?: AccountInfo;
}

type Payloads = {
  [ActionType.ACCOUNT_INFO_LOADED]: {
    accountInfo: AccountInfo;
  };
};

export type Action = ActionMap<ActionType, Payloads>;

export type ScreenState = MakeRequired<State, "accountInfo">;

export interface ScreenProps {
  state: ScreenState;
  dispatch: Dispatch<Action>;
}
